var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "el-row",
    [
      _c("GeneralTable", {
        ref: "GeneralTable",
        attrs: {
          operation: _vm.operation,
          "table-name": _vm.tableName,
          "row-key": "c_id",
          url: _vm.url,
          "can-search": _vm.canSearch,
          "can-add": _vm.canAdd,
          "can-edit": _vm.canEdit,
          "can-delete": _vm.canDelete,
          "can-download": _vm.canDownload,
          "can-batch-edit": _vm.canBatchEdit,
        },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }